import { render, staticRenderFns } from "./ChartjsHorizontalBarChartWorkerBottom.vue?vue&type=template&id=90343622&"
import script from "./ChartjsHorizontalBarChartWorkerBottom.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartWorkerBottom.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartWorkerBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports